//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamTraProKategorieUdalostiDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-11-08                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=482.71.X1
//AdtGeneratorConfig:[ T:(gincevn) V1:(ktg_evn,ktg_evn_txt,k_v,k_s,dat_do,dat_do_exp,dat_do_prn,dat_do_xml,dat_do_evn,dat_zmena,dat_do_akt) V2:(priz_gen,priz_prn,priz_xml,priz_evn,zmenu_prov,priz_zobr) K1:() K2:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamZastupDesigner
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class SeznamTraProKategorieUdalostiDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ktg_evn */
            public ktg_evn: Number;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GTraProKategorieUdalostiDto>;

        /** vytvo�it form�t seznamu - definice sloupc�, napdpis�, ���ek atd... */
        static createGridFormat(that: GContentType<SeznamTraProKategorieUdalostiDesigner>): Gordic.Data.GridFormat {

            var columnsDefinition = this.createGridFormatBase(that);

            columnsDefinition
                .addNumberColumn({
                                    name: "ktg_evn",
                                    caption: "jres:29924370", //RC 29924370 : Kategorie ud�losti
                                    width: 150,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "ktg_evn_txt",
                                    caption: "jres:29924371", //RC 29924371 : N�zev kategorie
                                    width: 300,
                                    fragment: ""
                })
                .addNumberColumn({
                                    name: "k_v",
                                    caption: "jres:29924369", //RC 29924369 : 
                                    width: 150,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "k_s",
                                    caption: "jres:29924368", //RC 29924368 : 
                                    width: 300,
                                    fragment: ""
                })
                .addDateTimeColumn({
                                    name: "dat_do",
                                    caption: "jres:29924360", //RC 29924360 : Datum sledov�n� DO
                                    width: 150,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "priz_gen_txt",
                                    caption: "jres:29924374", //RC 29924374 : P��znak sledov�n�
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "priz_prn_txt",
                                    caption: "jres:29924375", //RC 29924375 : Exportovat do PDF
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "priz_xml_txt",
                                    caption: "jres:29924376", //RC 29924376 : Exportovat do XML
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "priz_evn_txt",
                                    caption: "jres:29924372", //RC 29924372 : Exportovat do  ESB 
                                    width: 300,
                                    fragment: ""
                })
                .addDateTimeColumn({
                                    name: "dat_do_exp",
                                    caption: "jres:29924363", //RC 29924363 : Posledn� �as exportu do log.syst�mu
                                    width: 150,
                                    fragment: ""
                })
                .addDateTimeColumn({
                                    name: "dat_do_prn",
                                    caption: "jres:29924364", //RC 29924364 : Posledn� �as exportu do PDF
                                    width: 150,
                                    fragment: ""
                })
                .addDateTimeColumn({
                                    name: "dat_do_xml",
                                    caption: "jres:29924365", //RC 29924365 : Posledn� �as exportu do XML
                                    width: 150,
                                    fragment: ""
                })
                .addDateTimeColumn({
                                    name: "dat_do_evn",
                                    caption: "jres:29924362", //RC 29924362 : Posledn� �as exportu do ESB
                                    width: 150,
                                    fragment: ""
                })
                .addDateTimeColumn({
                                    name: "dat_zmena",
                                    caption: "jres:29930674", //RC 29930674 : Zm�n�no
                                    width: 150,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "zmenu_prov_txt",
                                    caption: "jres:29930694", //RC 29930694 : Zm�nil
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "priz_zobr_txt",
                                    caption: "jres:29924377", //RC 29924377 : Zobrazovat
                                    width: 300,
                                    fragment: ""
                })
                .addDateTimeColumn({
                                    name: "dat_do_akt",
                                    caption: "jres:29924361", //RC 29924361 : 
                                    width: 150,
                                    fragment: ""
                })

            return columnsDefinition;
        } // createGridFormat

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamTraProKategorieUdalostiDesigner>): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true);

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamTraProKategorieUdalostiDesigner>): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        /**
         * SeznamTraProKategorieUdalostiDesignerInit
         * 
         * @param {GContentType<SeznamTraProKategorieUdalostiDesigner>} that
         */
        static SeznamTraProKategorieUdalostiDesignerInit(that: GContentType<SeznamTraProKategorieUdalostiDesigner>) {

            that.gridSearchColumns = "ktg_evn,ktg_evn_txt,k_v,k_s,dat_do,priz_gen_txt,priz_prn_txt,priz_xml_txt,priz_evn_txt,dat_do_exp,dat_do_prn,dat_do_xml,dat_do_evn,dat_zmena,zmenu_prov_txt,priz_zobr_txt,dat_do_akt".split(",");

            SeznamBase.SeznamBaseInit(that as GContentType<SeznamBase>);

            that.filter = this.createFilter(that);

            that.gridFormat = this.createGridFormat(that);

            that.view = new Gordic.Isl.View(that.isl.TraProKategorieUdalosti.list(), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem

        } // SeznamTraProKategorieUdalostiDesignerInit

    }
}
